import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface PromoInterface {
  closedPromos: string[]
  closePromo: (promoId: string) => void
}

export const createPromoStore = (storage: StateStorage) =>
  createStore<PromoInterface>(
    storage,
    (set, get) => ({
      closedPromos: [],
      closePromo: (promoId) => {
        const { closedPromos } = get()
        if (!closedPromos.includes(promoId)) {
          set({ closedPromos: [...closedPromos, promoId] })
        }
      },
    }),
    {
      persist: {
        name: 'promo',
        version: 0,
      },
    }
  )
